UC.views.AccountNewBankAccount = Backbone.View.extend({

  initialize: function() {
    this.bankAccountForm = new UC.partials.BankAccountForm({
      el: '#formBankAccount'
    });
  }

});
